module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/main-bg_687e67c32bce80fbf2c19251cfc06aa1.jpg";